import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-2xl font-semibold text-700 pl-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-1 border-300 mt-1" }, null, -1)
const _hoisted_4 = { class: "flex flex-column gap-5" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-column gap-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsCard = _resolveComponent("EventsCard")!

  return (_ctx.grouped)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: event.id
          }, [
            (index === 0)
              ? (_openBlock(), _createBlock(_component_EventsCard, {
                  key: 0,
                  event: event,
                  showcase: "",
                  onSave: ($event: any) => (_ctx.$emit('save', event)),
                  onUnsave: ($event: any) => (_ctx.$emit('unsave', event))
                }, null, 8, ["event", "onSave", "onUnsave"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedEvents, (group, date) => {
          return (_openBlock(), _createElementBlock("div", { key: date }, [
            _createElementVNode("div", {
              class: _normalizeClass(["pt-6 pb-3", {
          hidden: group.length === 1 && group[0].id === _ctx.firstEvent.id,
        }])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(date !== "undefined" ? date : ""), 1),
              _hoisted_3
            ], 2),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (event) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: event.id,
                  class: _normalizeClass({
            hidden: event.id === _ctx.firstEvent.id,
          })
                }, [
                  (event.id !== _ctx.firstEvent.id)
                    ? (_openBlock(), _createBlock(_component_EventsCard, {
                        key: 0,
                        event: event,
                        onSave: ($event: any) => (_ctx.$emit('save', event)),
                        onUnsave: ($event: any) => (_ctx.$emit('unsave', event))
                      }, null, 8, ["event", "onSave", "onUnsave"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
          return (_openBlock(), _createBlock(_component_EventsCard, {
            key: event.id,
            event: event,
            showcase: index === 0,
            onSave: ($event: any) => (_ctx.$emit('save', event)),
            onUnsave: ($event: any) => (_ctx.$emit('unsave', event))
          }, null, 8, ["event", "showcase", "onSave", "onUnsave"]))
        }), 128))
      ]))
}